<template>
    <!-- Eventually the users name will become a clickable link -->
    <v-list-item-content>
        <v-list-item-title>{{activity.action}} a <b color="primary" @click="viewActivity(activity.what.id)">{{activity.what.type}}</b> {{diffInDays}}</v-list-item-title>
    </v-list-item-content>
</template>

<script>
import moment from 'moment'

export default {
    data () {
        return {
        }
    },
    components: {

    },
    props: {
        activity: Object
    },
    computed: {
        diffInDays(){
            var activityDate = moment(this.activity.date)
            var now = moment();

            return activityDate.from(now);
        }
    },
    mounted(){   
    },
    methods: {
        viewActivity(id){
            //This will emit an event to view the treatment or comment
            if (this.activity.what.type === "Treatment") {
                this.$emit("viewTreatment", id);
            } else {
                this.$emit("viewComment", id);
            }
        }
    }
}
</script>